module.exports = __webpack_public_path__ + "img/academy_transactions.c83b87f8.svg";